export const listDefaultContent = {
    en: {
        listTexts: {
            0: {
                content: 'Engage all senses to fully experience the moment.',
            },
            1: {
                content: 'Practice gratitude for the present.',
            },
            2: {
                content: 'Embrace opportunities the future might hold; act now with intention.',
            }
        }
    },
    es: {
        listTexts: {
            0: {
                content: 'Involucra todos los sentidos para experimentar plenamente el momento.',
            },
            1: {
                content: 'Practica la gratitud por el presente.',
            },
            2: {
                content: 'Aprovechar las oportunidades que el futuro pueda deparar; Actúa ahora con intención.',
            }
        }
    }
}
